// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__703bi","marginVertical":"spinner_marginVertical__EDTIB","spin":"spinner_spin__RaNeO","noTextContainer":"spinner_noTextContainer__Xe6mu"};